import { render, staticRenderFns } from "./ModifyBroker.vue?vue&type=template&id=a2a0e4f2&"
import script from "./ModifyBroker.vue?vue&type=script&lang=ts&"
export * from "./ModifyBroker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports